import { Accordion, Box } from "@chakra-ui/react";
import Event from "./Event";

export default function EventLog({ events }) {
    const eventsToDisplay = [];

    events.forEach((event) => {

      if (event.type.endsWith("delta")){
        return;
      }

        eventsToDisplay.push(
            <Event
                key={event.event_id}
                event={event}
                timestamp={new Date().toLocaleTimeString()}
            />
        );
    });

    return (
        <Box>
            {events.length === 0 ? (
                <Box textAlign="center" color="gray.500" py={8}>
                    No events yet. Start a session to see events here.
                </Box>
            ) : (
                <Accordion allowMultiple>{eventsToDisplay}</Accordion>
            )}
        </Box>
    );
}
